const BASE_URL = process.env.REACT_APP_DOMAIN;
const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT;

export { BASE_URL, CHECKOUT_URL };
